

























































































import {Component, Prop, Vue} from "vue-property-decorator";
import RenderPrice from "@/components/Shared/RenderPrice.vue";
import OrderPaymentHistoryItem from "@/api/OrderPaymentHistoryItem";

@Component({
  components: {RenderPrice}
})
export default class OrderPaymentDetailsView extends Vue {
  @Prop() private orderPaymentHistory!: OrderPaymentHistoryItem[];
}
